import React, { useEffect, useState } from "react";
import { NumberToampm, isEmptyDash } from "../../constant";
import FilePresent from "../../assests/images/file-present.png";
import flag from "../../assests/images/flag.png";
import { UserObj } from "../../services/localStarage";

function ChatActiveUser(props) {
    let [profilePic, setProfilePic] = useState(null);
    let [DifferenceTime, setDifferenceTime] = useState('');


    useEffect(() => {
        const profilePicUrl = sessionStorage.getItem('profilePicUrl');
        setProfilePic(profilePicUrl);


    }, []);

    const viewMedia = (data) => {        
        props.viewUrlData(data);
    };

    const isTimeDifferencePositive = (data) => {
        if (!data?.previous) {
            return false;
        }
        const previousTime = new Date(data?.createdAt);
        const currentTime = new Date(data?.previous?.createdAt);

        var diff = (currentTime.getTime() - previousTime.getTime()) / 1000;
        // Convert the difference from seconds to minutes
        diff /= 60;
        // Return the absolute value of the rounded difference in minutes
        let differenceInMinutes = Math.abs(Math.round(diff));

        // const differenceInMilliseconds = currentTime - previousTime;
        // const differenceInMinutes = Math.floor(differenceInMilliseconds / (1000 * 60));
        if (differenceInMinutes > 0) {
            return false;
        } else {
            return true;
        }
    }

    return (
        <>
            <div className="right-chat-sec">
                <div>
                    <div>

                        <div style={{ marginBottom: '10px' }}>
                            {/* <div className="chat-right-sec">
                                    {props?.data?.comment}
                                </div> */}
                            <div className="div-right-chat">
                                <span style={{ display: 'block', fontSize: '12px', color: '#4D4A4A' }}>{props?.data?.commentByUser?.name}  {(props?.data?.commentByUser?.role) ? ` (${props?.data?.commentByUser?.role})` : ''} </span>

                                {/* {(!isEmptyDash(props?.data?.referenceURL)) ? */}
                                {props?.data?.files && props.data.files.length > 0 && !isEmptyDash(props.data.files[0].key) ?
                                    <span>
                                        <img className="refrence-img" src={FilePresent} onClick={() => viewMedia(props?.data?.files[0])} alt="" /><br />
                                        <span style={{ fontSize: '8px' }}>{props?.data?.files[0]?.name}</span>
                                    </span>
                                    :

                                    <div className="chat-right-sec" style={{ marginRight: '4px', borderRadius: '5px' }} >
                                        {props?.data?.comment}
                                    </div>}
                            </div>
                            <div className="chat-user-double-tick">
                                <span style={{ fontSize: '12px', float: 'left', marginBottom: '10px', width: '100%', color: '#9F9FA6' }}><i class="fa fa-check-double"></i>{" "}
                                    {/* {(!isTimeDifferencePositive(props.data)) ? NumberToampm(props?.data?.updatedAt) : ''} */}
                                    {!isTimeDifferencePositive(props.data) && (
                                        <React.Fragment>
                                            {NumberToampm(props?.data?.updatedAt)}
                                            {props?.data?.isVendor === false && props?.data?.isPublic === false && (
                                                <img style={{ paddingLeft: '4px', width: '16px' }} src={flag} alt="" />
                                            )}
                                        </React.Fragment>
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="div-right-chat-logo-div">
                        {!isEmptyDashNew(profilePic) && <img src={profilePic} className="div-right-chat-user-img" />}
                        
                        {isEmptyDashNew(profilePic) && <span className="avatar avatar-sm rounded-circle">
                            {" "}
                            {partialHeadName}{" "}
                        </span>}
                    </div> */}
            </div>
        </>
    );
}

export default ChatActiveUser;

